import { errorText } from '../../utils/errorText';

/**
 * What a failed load says on screen in the teacher, mentor and lesson Q&A pages (spec §3.12, §5:
 * never `err.message`, axios text or the backend's English).
 *
 * The API client (api/client.js) already words the failures nobody can act on in the user's
 * language (offline, timed out, too many requests, server down) and marks them with
 * `messageKey: 'shell.errors.*'`; utils/errorText hands that sentence back and nothing else. A
 * failure is therefore two lines: the page's own translated sentence about WHAT could not be
 * loaded (the title), and, when the client has one, WHY and what to do about it (the detail).
 * An error card puts them in `title` and `description`, so the two never repeat each other:
 *
 *   setError(failure(err, t('teacher.dashboard.failedToLoadStudents')));
 *   <PageEmptyState variant="error" title={error.title} description={error.detail} onRetry={retry} />
 *   <div className="ui-alert" role="alert"><p>{failureText(error)}</p></div>
 *
 * Without a detail the card shows its own calm "try again" line.
 */
export { errorText };

/** `{ title, detail }`: the page's sentence, plus the API client's own when it has one. */
export function failure(err, title) {
  return { title, detail: errorText(err, '') || undefined };
}

/** The failure as one line, for an inline alert: "O'quvchilarni yuklab bo'lmadi. Serverga ulanib bo'lmadi..." */
export function failureText(value) {
  if (!value) return '';
  if (typeof value === 'string') return value;
  const { title = '', detail = '' } = value;
  if (!title || !detail) return title || detail;
  return `${title}${/[.!?…:]$/.test(title) ? ' ' : '. '}${detail}`;
}

export default errorText;
